import { ValidatorFn } from '@angular/forms'
import { Subject } from 'rxjs/Subject'

import { ControlTypes } from '../'

export interface IBasePromptOptions<T> {
  value?: T,
  key?: string,
  label?: string,
  validators?: ValidatorFn[],
  controlType?: ControlTypes
}

export class BasePrompt<T> {
  public key: string
  public label: string
  public validators: ValidatorFn[]
  public controlType: ControlTypes

  public onValueChanged: Subject<T> = new Subject<T>()

  public set value(value: T) {
    this.setValue(value)
  }

  public get value(): T {
    return this._value
  }

  private _value: T

  public constructor(options: IBasePromptOptions<T> = {}) {
    this.value = options.value
    this.key = options.key || ''
    this.label = options.label || ''
    this.validators = options.validators || []
    this.controlType = options.controlType
  }

  public setValue(value, options = {emit: true}) {
    if (this._value != value) {
      this._value = value
      if (options.emit) {
        this.onValueChanged.next(value)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/forms/models/prompt/base-prompt.ts